import { useParams, Link } from 'react-router-dom';
import { SHOP_PRODUCTS } from '@/data/content';
import Breadcrumb from '@/components/ui/Breadcrumb';

export default function ShopDetailPage() {
  const { productId } = useParams<{ productId: string }>();
  const product = SHOP_PRODUCTS.find((p) => p.id === productId);

  if (!product) return <div className="max-w-4xl mx-auto px-6 pt-8"><p className="text-text-disabled">商品未找到</p></div>;

  return (
    <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
      <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '商城', href: '/shop' }, { label: product.name }]} />

      <div className="flex flex-col md:flex-row items-start gap-8 mb-12">
        <div className="w-full md:w-80 h-72 bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt flex items-center justify-center shrink-0">
          <img src={product.image} alt={product.name} className="h-60 w-auto object-contain" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded-tag bg-arena-blue/15 text-arena-blue">{product.creatorType === 'official' ? '官方' : '社区'}</span>
            <span className="text-xs text-text-disabled">{product.category}</span>
          </div>
          <h1 className="text-xl font-extrabold text-text-primary mb-2">{product.name}</h1>
          <div className="flex items-center gap-1.5 mb-4">
            <div className="w-5 h-5 rounded-full bg-border-dark" />
            <span className="text-sm text-text-secondary">{product.creator}</span>
          </div>
          <div className="flex items-baseline gap-3 mb-5">
            <span className="text-2xl font-extrabold text-text-primary">{product.price}</span>
            {product.originalPrice && <span className="text-sm text-text-disabled line-through">{product.originalPrice}</span>}
          </div>
          <div className="flex items-center gap-4 text-xs text-text-secondary mb-6">
            <span>{product.sales.toLocaleString()} 已售</span>
            <span className="text-arena-gold font-medium">{product.rating} 分</span>
          </div>
          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <span className="text-xs text-text-disabled w-16">数量</span>
              <div className="flex items-center border border-border-dark rounded-btn">
                <button className="w-8 h-8 text-text-secondary hover:text-text-primary text-sm">-</button>
                <span className="w-10 text-center text-sm text-text-primary">1</span>
                <button className="w-8 h-8 text-text-secondary hover:text-text-primary text-sm">+</button>
              </div>
            </div>
          </div>
          <div className="flex gap-3">
            <button className="px-8 h-10 rounded-btn bg-arena-red text-white text-sm font-bold hover:brightness-110 transition-all">加入购物车</button>
            <button className="px-8 h-10 rounded-btn bg-arena-gold text-bg-black text-sm font-bold hover:brightness-110 transition-all">立即购买</button>
          </div>
        </div>
      </div>

      {/* Related */}
      <div className="border-t border-border-dark pt-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-extrabold text-text-primary">相关商品</h2>
          <Link to="/shop" className="text-xs text-arena-blue hover:underline">返回商城</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {SHOP_PRODUCTS.filter((p) => p.id !== product.id).slice(0, 4).map((p) => (
            <Link key={p.id} to={`/shop/${p.id}`} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/40 transition-all group text-center">
              <img src={p.image} alt={p.name} className="h-20 w-auto mx-auto object-contain mb-2" />
              <p className="text-xs text-text-primary truncate">{p.name}</p>
              <p className="text-sm font-bold text-arena-gold mt-1">{p.price}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
